
export const statusOptions = [
  { label: "下单成功", value: 1, type: "" },
  { label: "已提交", value: 2, type: "info" },
  { label: "生成成功", value: 3, type: "success" },
  { label: "生成失败", value: 4, type: "danger" },
  { label: "退款", value: 5, type: "warning" },
];

export const findLabel = (val, opts) => {
  const cur = opts.find((v) => v.value === val);
  if (cur) return cur.label;
  return "-";
};

export const findStatusLabel = (val) => {
  const label = findLabel(val, statusOptions);
  return label;
};

export const findStatusType = (val) => {
  const cur = statusOptions.find((v) => v.value === val);
  if (cur) return cur.type;
  return "";
};
